
import axios from 'axios'
// import { Post } from 'utils/axios';
import { baseURL, auth } from 'config/config';
import { Get, Patch, Post, Delete } from 'utils/axios';


/** 
* 获取token
* @param {Object} param: 参数对象
*/
export function reqLogin(param) {
  const url = 'oauth/token'
  const method = 'post'
  const params = {
    username: param ? param.username : 'vs123456',
    password: param ? param.password : 'MTIzNDU2',
    grant_type: 'password'
  }

  return axios.request({ baseURL, params, method, url, auth })
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(error => {
      return Promise.reject(error.response)
    })
}


/** 
 * 退出
 * @param {object} param: 参数对象
*/
export function reqLogout(params) {
  const url = 'vs/logout'
  return Get(url, params)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

/** 
 * 首页资源列表(最新/最热)
 * @param {object} param: 参数对象
*/
export function reqGetHomeData(params) {
  const url = '/api/v1/index'
  return Get(url, params, false, {
    headers: {
      token: false
    }
  })
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

